<template>
  <div>
    <AppHeader />
    <NuxtLoadingIndicator color="#f15822" :height="3" />
    <div id="smooth-wrapper">
      <div id="smooth-content">
        <main id="main-content">
          <NuxtPage />
        </main>
        <AppFooter />
      </div>
    </div>
  </div>
</template>
